var React = require('react');

function Ball23 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4.498 -2.25)"},[React.createElement("path",{"d":"M68.144,9.623c-9,0-12.8,4.29-19.073,4.29-6.423,0-11.333-4.26-19.127-4.26A26.093,26.093,0,0,0,9,22.244c-7.26,11.189-6.023,32.271,5.73,50.212,4.207,6.426,9.82,13.631,17.187,13.71h.133c6.4,0,8.3-4.187,17.113-4.237H49.3c8.667,0,10.42,4.214,16.793,4.214h.133c7.363-.08,13.283-8.064,17.487-14.467a69.667,69.667,0,0,0,6.457-12.122,21.978,21.978,0,0,1-2.92-39.779A25.392,25.392,0,0,0,68.1,9.63Z","transform":"translate(0 16.084)","key":0}),React.createElement("path",{"d":"M37.93,2.25a23.63,23.63,0,0,0-15.3,8.245,20.359,20.359,0,0,0-4.991,15.863h.431A20.116,20.116,0,0,0,33.056,18.5,21.823,21.823,0,0,0,37.934,2.25Z","transform":"translate(28.247 0)","key":1})]));
}

Ball23.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Ball23;

Ball23.default = Ball23;
